const DEFAULT_GROUP_ID = 1;
const transformTokenV2Response = ({ token , store_data: { website_id , store_id , store , website , group_id  } = {}  })=>({
        token,
        sessionData: {
            websiteId: website_id,
            storeId: store_id,
            store,
            website,
            groupId: group_id
        }
    });
const transformSalesAgentTokenV2Response = ({ token , store_data: { website_id , store_id , store , website /*group_id*/  } = {}  })=>({
        token,
        sessionData: {
            websiteId: website_id,
            storeId: store_id,
            store,
            website,
            groupId: DEFAULT_GROUP_ID
        }
    });

export { transformSalesAgentTokenV2Response, transformTokenV2Response };
